import * as React from "react";
import here_img from "../../assets/images/edu_img_4.jpg";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
const HomePageHero = () => {
  return (
    <div className="flex justify-center flex-col items-center lg:min-h-screen h-auto lg:pt-[100px] pt-36 w-full" id="home">
      <div className=" flex lg:flex-row flex-col justify-between  lg:gap-20 gap-10 items-center">
        <div className="lg:w-2/3 flex flex-col justify-center ">
          <p className="font-teacher text-base sm:pb-5 pb-3 text-[#005064] font-bold md:tracking-[4px] tracking-[2px] uppercase">
            Welcome to SLN Educational Society
          </p>
          <h1
            className="xl:text-5xl sm:text-4xl text-3xl font-semibold  py-4 text-[#1a1a1a]"
            style={{
              lineHeight: "1.2em",
            }}
          >
            Learning Without Limits, Growing Without Boundries
          </h1>
          <p className=" text-base sm:py-5 py-3 text-[#1a1a1a] sm:pe-20 pe-8">
            SLN Educational Society welcomes students, families, educators,
            partners, and communities to be part of a transformative journey.
            Together, we can build institutions that inspire excellence today
            and create opportunities for generations to come.
          </p>
          <div className="flex flex-row gap-4 sm:py-6 py-3">
            <Link to="/contact" className="py-2.5 px-6 flex flex-row justify-center items-center gap-2  border border-[#005064] hover:bg-[#D4E9EF] opacity-70 hover:text-[#005064] bg-[#005064] text-[#D4E9EF]  rounded-full text-base transition-all duration-200">
             Contact Us <ArrowForwardIcon />
            </Link>
          </div>
        </div>

        <div className="">
          <img src={here_img} alt="" className="w-full rounded-lg" />
        </div>
      </div>
    </div>
  );
};

export default HomePageHero;
